// src/components/RoleRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useHelperOnboarding } from "../context/HelperOnboardingContext";
import { normalizeRole, ROLE_VALUE } from "../constants/roleLabels";
import { logger } from "../utils/logger";

export default function RoleRoute({ children, allowedRoles }) {
  const { currentUserRole, ready } = useAuth();
  const { requiresOnboarding, loadingDraft } = useHelperOnboarding();
  const location = useLocation();

  if (!ready) return <div>Loading...</div>;

  // Wait for onboarding state before making redirect decisions for helpers
  if (normalizeRole(currentUserRole) === ROLE_VALUE.specialist && loadingDraft) {
    return <div>Loading...</div>;
  }

  const role = normalizeRole(currentUserRole);
  logger.log("🛡️ RoleRoute: currentUserRole =", role);
  logger.log("🛡️ RoleRoute: allowedRoles =", allowedRoles);

  if (!role || !allowedRoles.includes(role)) {
    logger.log("🚫 RoleRoute: Role not allowed → redirect to /");
    return <Navigate to="/" replace />;
  }

  if (
    role === ROLE_VALUE.specialist &&
    !loadingDraft &&
    requiresOnboarding &&
    location.pathname !== "/onboarding"
  ) {
    logger.log("🔁 RoleRoute: Redirecting helper to onboarding");
    return <Navigate to="/onboarding" replace />;
  }

  logger.log("✅ RoleRoute: Access granted");
  return children;
}
